import JustValidate from 'just-validate';
import axios from 'axios';
import { layer } from '../plugins/layer/index.js';

import 'choices.js/src/styles/choices';
import Choices from 'choices.js';

import { checkViewTransition } from '../utiles/index.js';

const initForms = (lang) => {
	const contactForm = document.getElementById('contactForm');
	if (contactForm) {
		const choicesTypeElm = document.querySelector('.js-choices-type');

		const layerSuccess = document.querySelector('.layer-success-submit');
		const btnCloseLayerSuccess = layerSuccess.querySelector('.btn-close-layer-success');
		btnCloseLayerSuccess.addEventListener('click', () => {
			checkViewTransition(() => {
				layerSuccess.classList.add('hidden');
			});
		});

		const choicesType = new Choices(choicesTypeElm, {
			searchEnabled: false,
			itemSelectText: '',
			shouldSort: false,
		});

		const validate = new JustValidate(contactForm);
		const postURL = contactForm.getAttribute('action');
		validate
			.addField('.cform__name', [{ rule: 'required', errorMessage: lang.fillName }])
			.addField('.cform__phone', [
				{ rule: 'required', errorMessage: lang.fillTel },
				// { rule: 'customRegexp', value: lang.regexpTel, errorMessage: lang.phoneErr },
			])
			.addField('.cform__email', [
				{ rule: 'required', errorMessage: lang.fillEmail },
				{ rule: 'email', errorMessage: lang.emailErr },
			])
			.addField('.cform__region', [{ rule: 'required', errorMessage: lang.fillRegion }])
			.addField('.cform__type', [{ rule: 'required', errorMessage: lang.selectType }], {
				errorsContainer: '#type-error-box', // ← 指定容器！
			})

			.addField('.cform__message', [{ rule: 'required', errorMessage: lang.fillMsg }])
			.onSuccess((event) => {
				console.log('success');

				const formData = new FormData(contactForm);
				const serializedData = new URLSearchParams(formData).toString();

				// console.log(serializedData);

				axios
					.post(postURL, serializedData, {
						headers: {
							// 'X-WP-Nonce': WP_NONCE,
						},
					})
					.then(function (res) {
						// console.log(res);
						if (res.status == '200') {
							layer.msg(res.data.msg);
							setTimeout(() => {
								contactForm.reset();
								checkViewTransition(() => {
									layerSuccess.classList.remove('hidden');
								});
							}, 2000);
						} else {
							layer.msg(res.data.msg);
						}
					})
					.catch(function (err) {
						console.log(err);
					});
			});
	}
};

export { initForms };
